import React from "react";
import { Route, Navigate, useParams } from "react-router-dom";
import ListingsUnified from "../pages/ListingsUnified";
import ListingTypeSelector from "../pages/ListingTypeSelector";
import { SafeFormWrapper } from "../components/forms";
import ProductBundleForm from "../pages/ProductBundleForm";
import ProductDetails from "../pages/ProductDetails";
import BulkProductEditor from "../pages/BulkProductEditor";
import ServicesNew from "../pages/ServicesNew";
import ServiceDetails from "../pages/ServiceDetails";
import Rentals from "../pages/Rentals";
import RentalDetails from "../pages/RentalDetails";
import Subscriptions from "../pages/Subscriptions";
import SubscriptionDetails from "../pages/SubscriptionDetails";
import Events from "../pages/Events";
import EventDetails from "../pages/EventDetails";
import Classifieds from "../pages/Classifieds";
import ClassifiedDetails from "../pages/ClassifiedDetails";
import Volunteering from "../pages/Volunteering";
import VolunteeringDetails from "../pages/VolunteeringDetails";
import RatingsReviews from "../pages/RatingsReviews";

const EditRedirect = ({ category }) => {
  const { id } = useParams();
  return <Navigate to={`/edit-listing/${category}/${id}`} replace />;
};

const ListingIdRedirect = () => {
  const { id } = useParams();
  return <Navigate to={`/edit-listing/product/${id}`} replace />;
};

/**
 * Listing CRUD + detail routes.
 * Every route here requires PrivateRoute wrapping.
 */
export const ListingRoutes = ({ PrivateRoute }) => (
  <>
    <Route path="/listings" element={<PrivateRoute><ListingsUnified /></PrivateRoute>} />
    <Route path="/vendor/listings" element={<PrivateRoute><ListingsUnified /></PrivateRoute>} />
    <Route path="/bulk-product-editor" element={<PrivateRoute><BulkProductEditor /></PrivateRoute>} />
    {/* Universal Form Routes */}
    <Route path="/create-listing" element={<PrivateRoute><ListingTypeSelector /></PrivateRoute>} />
    <Route path="/create-listing/:category" element={<PrivateRoute><SafeFormWrapper /></PrivateRoute>} />
    <Route path="/edit-listing/:category/:listingId" element={<PrivateRoute><SafeFormWrapper /></PrivateRoute>} />
    {/* Redirect old products listing to unified page */}
    <Route path="/listings/products" element={<Navigate to="/listings" replace />} />
    <Route path="/listings/products/new" element={<PrivateRoute><Navigate to="/create-listing/product" replace /></PrivateRoute>} />
    <Route path="/listings/products/edit/:id" element={<PrivateRoute><EditRedirect category="product" /></PrivateRoute>} />
    <Route path="/listings/products/bundle" element={<PrivateRoute><ProductBundleForm /></PrivateRoute>} />
    <Route path="/listings/products/:id" element={<PrivateRoute><ProductDetails /></PrivateRoute>} />
    {/* Services */}
    <Route path="/listings/services" element={<Navigate to="/listings" replace />} />
    <Route path="/listings/services/new" element={<PrivateRoute><Navigate to="/create-listing/service" replace /></PrivateRoute>} />
    <Route path="/listings/services/edit/:id" element={<PrivateRoute><EditRedirect category="service" /></PrivateRoute>} />
    <Route path="/listings/services/:id" element={<PrivateRoute><ServiceDetails /></PrivateRoute>} />
    <Route path="/listings/reviews" element={<PrivateRoute><RatingsReviews /></PrivateRoute>} />
    {/* Rentals */}
    <Route path="/listings/rentals" element={<PrivateRoute><Rentals /></PrivateRoute>} />
    <Route path="/listings/rentals/new" element={<PrivateRoute><Navigate to="/create-listing/rental" replace /></PrivateRoute>} />
    <Route path="/listings/rentals/edit/:id" element={<PrivateRoute><EditRedirect category="rental" /></PrivateRoute>} />
    <Route path="/listings/rentals/:id" element={<PrivateRoute><RentalDetails /></PrivateRoute>} />
    {/* Subscriptions */}
    <Route path="/listings/subscriptions" element={<PrivateRoute><Subscriptions /></PrivateRoute>} />
    <Route path="/listings/subscriptions/new" element={<PrivateRoute><Navigate to="/create-listing/subscription" replace /></PrivateRoute>} />
    <Route path="/listings/subscriptions/edit/:id" element={<PrivateRoute><EditRedirect category="Subscriptions" /></PrivateRoute>} />
    <Route path="/listings/subscriptions/:id" element={<PrivateRoute><SubscriptionDetails /></PrivateRoute>} />
    {/* Events */}
    <Route path="/listings/events" element={<PrivateRoute><Events /></PrivateRoute>} />
    <Route path="/listings/events/new" element={<PrivateRoute><Navigate to="/create-listing/event" replace /></PrivateRoute>} />
    <Route path="/listings/events/edit/:id" element={<PrivateRoute><EditRedirect category="event" /></PrivateRoute>} />
    <Route path="/listings/events/:id" element={<PrivateRoute><EventDetails /></PrivateRoute>} />
    {/* Classifieds */}
    <Route path="/listings/classifieds" element={<PrivateRoute><Classifieds /></PrivateRoute>} />
    <Route path="/listings/classifieds/new" element={<PrivateRoute><Navigate to="/create-listing/classified" replace /></PrivateRoute>} />
    <Route path="/listings/classifieds/edit/:id" element={<PrivateRoute><EditRedirect category="classified" /></PrivateRoute>} />
    <Route path="/listings/classifieds/:id" element={<PrivateRoute><ClassifiedDetails /></PrivateRoute>} />
    {/* Volunteering */}
    <Route path="/listings/volunteering" element={<PrivateRoute><Volunteering /></PrivateRoute>} />
    <Route path="/listings/volunteering/new" element={<PrivateRoute><Navigate to="/create-listing/volunteering" replace /></PrivateRoute>} />
    <Route path="/listings/volunteering/edit/:id" element={<PrivateRoute><EditRedirect category="Volunteering" /></PrivateRoute>} />
    <Route path="/listings/volunteering/:id" element={<PrivateRoute><VolunteeringDetails /></PrivateRoute>} />
    {/* Catch-all: bare /listings/:id redirects to edit page */}
    <Route path="/listings/:id" element={<PrivateRoute><ListingIdRedirect /></PrivateRoute>} />
  </>
);
